/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import React from 'react';

var AvatarContext = /*#__PURE__*/React.createContext("default");
var AvatarContextProvider = function AvatarContextProvider(_ref) {
  var children = _ref.children,
    size = _ref.size;
  return /* @__PURE__ */React.createElement(AvatarContext.Consumer, null, function (inputSize) {
    return /* @__PURE__ */React.createElement(AvatarContext.Provider, {
      value: size || inputSize
    }, children);
  });
};

export { AvatarContextProvider, AvatarContext as default };
//# sourceMappingURL=AvatarContext.js.map
